if (!customElements.get('quick-order-checkout')) {
  customElements.define(
    'quick-order-checkout',
    class QuickOrderCheckout extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('button[name="checkout"]');
        this.message = this.querySelector('[role="alert"]');
        this.messageTitle = this.querySelector('[data-checkout-message]');
        this.messageHint = this.querySelector('[data-checkout-hint]');
        this.section = this.closest('.shopify-section');
        this.onQuantityChange = this.onQuantityChange || ((event) => {
          if (event.target.matches('quick-order-list input[type="number"]')) this.message.hidden = true;
        });
        this.section?.addEventListener('change', this.onQuantityChange);
        this.onSubmit = this.onSubmit || this.handleSubmit.bind(this);
        this.form.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmit);
        this.section?.removeEventListener('change', this.onQuantityChange);
      }

      showMessage(text, showHint = false) {
        this.messageTitle.textContent = text;
        this.messageHint.hidden = !showHint;
        this.message.hidden = false;
      }

      async handleSubmit(event) {
        if (this.allowCheckout) return;
        event.preventDefault();
        if (this.busy) return;

        this.busy = true;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.message.hidden = true;

        try {
          const list = this.closest('.shopify-section')?.querySelector('quick-order-list');
          const deadline = Date.now() + 10000;
          await new Promise((resolve) => setTimeout(resolve, 0));

          while (list && (list.requestStarted || list.queue?.length || list.hasPendingQuantityUpdate)) {
            if (Date.now() >= deadline) throw new Error('Quantity update timed out');
            await new Promise((resolve) => setTimeout(resolve, 50));
          }

          const response = await fetch(this.dataset.cartUrl, {
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            signal: AbortSignal.timeout(10000),
          });
          if (!response.ok) throw new Error('Cart request failed');
          const cart = await response.json();

          if (!cart.item_count) {
            this.showMessage(this.dataset.emptyMessage, true);
            list?.querySelector('input[type="number"]')?.focus({ preventScroll: true });
            return;
          }

          this.button.disabled = false;
          this.allowCheckout = true;
          this.form.requestSubmit(this.button);
        } catch (error) {
          this.showMessage(this.dataset.errorMessage);
        } finally {
          this.allowCheckout = false;
          this.busy = false;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    }
  );
}
